import React from 'react';
import { FormAlerts, Button, Field } from '@cordata/buffet';
import { Card, CardBody, CardFooter, Alert } from 'reactstrap';
import { Formik, Form } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Yup from 'yup';
import kebabcaseKeys from 'kebabcase-keys';

import { baseInstance as axios } from '~/utils';

const stayHome = 'Please call your manager and do not report to work today. Seek medical assistance if your symptoms worsen or you feel you need help.';
const reportToWork = 'Please report to work at your assigned time. We’re looking forward to seeing you then.';

const initialValues = {
  assessmentDate: new Date(),
  highTemp: undefined,
  lowTempComplications: undefined,
};

const validationSchema = Yup.object().shape({
  assessmentDate: Yup.date().required(),
  highTemp: Yup.boolean().required(),
  lowTempComplications: Yup.boolean().when(
    'highTemp',
    (v, s) => (
      !v
        ? s.required()
        : s.notRequired()
    ),
  ),
});

const yesNo = [{
  label: 'Yes',
  value: true,
}, {
  label: 'No',
  value: false,
}];

const B2WAssessmentForm = () => (
  <Formik
    displayName="B2WAssessmentFormik"
    validateOnBlur={false}
    validateOnChange={false}

    initialValues={initialValues}

    initalStatus={{
      reportToWork: undefined,
    }}

    validationSchema={validationSchema}

    onSubmit={(values, {
      setStatus, setErrors, setSubmitting,
    }) => {
      const p = {
        data: values,
        ...JSON.parse(localStorage.getItem('registration-info')),
        code: localStorage.getItem('registration-code'),
      };

      axios
        .post(
          'b2w/status',
          kebabcaseKeys(p, { deep: true }),
        )
        .then(() => {
          setStatus({
            report: !values.highTemp && !values.lowTempComplications,
          });
        })
        .catch((e) => {
          const errs = e.response ? e.response.data.errors : e;

          setErrors({ server: e });

          if (
            errs &&
            Object.keys(errs).some(er =>
              Object.keys(values).includes(er))
          ) {
            Object.keys(errs).forEach(er =>
              setErrors({ [er]: errs[er] !== 'Required' ? errs[er] : 'is required' }));
          }
        })
        .then(() => setSubmitting(false));
    }}
  >
    {({
      values,
      errors,
      status,
      handleReset,
      submitCount,
      isSubmitting,
    }) => (
      <Card>
        <Form noValidate>
          <CardBody>
            {submitCount >= 1 && errors && (
              <FormAlerts errors={errors} />
            )}

            <Field
              name="assessmentDate"
              type="date"
              required
              disabled
            />

            <Field
              name="highTemp"
              label=" Do you have a temperature of 100.4 or more?"
              type="radio-group"
              options={yesNo}
              required
              disabled={status}
            />

            {values.highTemp !== undefined && !values.highTemp && <Field
              name="lowTempComplications"
              label="Are you coughing or having trouble breathing?"
              type="radio-group"
              options={yesNo}
              disabled={status}
              required
            />}

            {submitCount >= 1 && status && (<Alert className="mb-0" color={status.report ? 'success' : 'danger'}>{status.report ? reportToWork : stayHome} <Button color="link" onClick={() => window.location.reload()} className="alert-link p-0">Start over.</Button></Alert>)}
          </CardBody>

          <CardFooter className="d-flex">
            <div className="mr-auto">
              <Button
                color="danger"
                type="button"
                outline
                disabled={isSubmitting || status}
                onClick={() =>
                  handleReset(initialValues)}
              >
                <FontAwesomeIcon icon="sync-alt" />
                <span className="d-none d-md-inline ml-2">Reset</span>
              </Button>
            </div>

            <div className="ml-auto">
              <Button
                type="submit"
                disabled={isSubmitting || status}
              >
                {isSubmitting ? 'Saving ...' : 'Save'}
              </Button>
            </div>
          </CardFooter>
        </Form>
      </Card>
    )}
  </Formik>
);

export default B2WAssessmentForm;
